import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table as Table2,
    Pagination,
    Checkbox,
    Modal,
    Upload,
    Transfer,
    Form,
    Col,
    Rate,
    Divider,
    Radio,
    message,
    Popconfirm,
    Alert, Spin, Switch
} from 'antd';
import { Redirect, Link, withRouter } from 'react-router-dom';
import store from "../store/store.js";
import { DeleteOutlined, UploadOutlined, EditOutlined, PlusOutlined, FolderAddOutlined } from '@ant-design/icons'
import moment from 'moment';
import 'braft-editor/dist/index.css'
import BraftEditor from 'braft-editor'
import Table from 'braft-extensions/dist/table'
import { ContentUtils } from 'braft-utils'

const { Option, OptGroup } = Select;
const { TextArea } = Input;
const { RangePicker } = DatePicker;
const options = {
    defaultColumns: 3, // 默认列数
    defaultRows: 3, // 默认行数
    withDropdown: true, // 插入表格前是否弹出下拉菜单
    columnResizable: true, // 是否允许拖动调整列宽，默认false
    exportAttrString: 'border="1" style="border-collapse: collapse"', // 指定输出HTML时附加到table标签上的属性字符串
    // includeEditors: [], // 指定该模块对哪些BraftEditor生效，不传此属性则对所有BraftEditor有效
    // excludeEditors: []  // 指定该模块对哪些BraftEditor无效
}

BraftEditor.use(Table(options))

class Edit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {
                id: props.id,
                editorState: BraftEditor.createEditorState(null),
            },
            visible: false,
            loading: false,
            loading2: false,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {


    }

    sub() {
        let that = this
        that.setState({
            loading: true
        })
        let arr = that.state.condition
        fetch('/ProjectResource/save', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 1) {
                    message.success(data.msg);
                    this.props.refresh()
                    this.mdchange()
                } else {
                    message.error(data.msg)
                    that.setState({
                        loading: false
                    })
                }
            })
    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            fetch('/ProjectResource/view', {
                method: "POST",
                body: JSON.stringify({
                    id: this.state.condition.id,
                })
            })
                .then(res => res.json())
                .then(data => {
                    data.data.editorState = BraftEditor.createEditorState(data.data.content)
                    data.condition = data.data ? data.data : {}
                    that.setState({
                        ...data
                    })
                })
        } else {
            that.setState({
                condition: {
                    id: this.props.id,
                    editorState: BraftEditor.createEditorState(null),
                },
                loading: false
            })
        }
    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.condition, { [name]: dateString })
        this.setState({
            condition: data
        })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(dates, dateStrings)
        let data = Object.assign({}, this.state.condition, { [name + '1']: dateStrings[0], [name + '2']: dateStrings[1] })
        this.setState({
            condition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, { [name]: value })
        this.setState({
            condition: data
        })
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, { [name]: value })
        this.setState({
            condition: data
        })
    }

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, { [name]: value })
        this.setState({
            condition: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Option value={item.id} key={index}>{item.name}</Option>
            )
        }
    }

    arrradio(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Radio value={item.id} key={index}>{item.name}</Radio>
            )
        }
    }

    arrCheckbox(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Checkbox value={item.id} key={index}>{item.name}</Checkbox>
            )
        }
    }

    editorChange = (editorState) => {
        let data = Object.assign({}, this.state.condition, { editorState: editorState, content: editorState.toHTML() })
        this.setState({
            condition: data
        })
    }

    // 上传图片
    picChange(name, info) {
        // console.log(info)
        if (info.file.status === 'uploading') {
            this.setState({ loading2: true });
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            // console.log(info.file.response)

            var fjlist = this.state.condition[name]
            if (!fjlist) {
                fjlist = []
            }
            if (info.file.response.status == 0) {
                message.error(info.file.response.msg)
                return;
            }
            fjlist = fjlist.concat(info.file.response)
            let data = Object.assign({}, this.state.condition, { [name]: fjlist })
            this.setState({
                condition: data,
                loading2: false,
            })
        }
    };

    delpic(index, name, e) {
        var fjlist = this.state.condition[name]
        fjlist.splice(index, 1)
        let data = Object.assign({}, this.state.condition, { [name]: fjlist })
        this.setState({
            condition: data,
        })
    }

    // 富文本上传附件
    picChange2(name, info) {
        // console.log(info)
        if (info.file.status === 'uploading') {
            this.setState({ loading2: true });
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            // console.log(info.file.response)
            if (info.file.response.status == 0) {
                message.error(info.file.response.msg)
                return;
            }
            let text = ContentUtils.insertText(this.state.condition[name], info.file.response.name, ['COLOR-00F', 'UNDERLINE'], {
                type: 'LINK', mutability: 'MUTABLE', data: {
                    href: info.file.response.url, target: '_blank',
                },
            })
            let data = Object.assign({}, this.state.condition, {
                [name]: text, content: text.toHTML()
            })
            this.setState({
                condition: data
            })
        }
    };

    getCompanyInfo = () => {
        let that = this
        let name = that.state.condition.name
        that.setState({
            getting: true
        })
        fetch('/ProjectResource/getCompanyInfo', {
            method: "POST",
            body: JSON.stringify({
                name,
            })
        })
            .then(res => res.json())
            .then(data => {
                that.setState({
                    getting: false
                })
                if (data.status == 0) {
                    message.error(data.msg)
                    return
                }
                let condition = Object.assign({}, this.state.condition, { ...data.data })
                this.setState({
                    condition
                })
            })
    }

    render() {
        //多媒体上传
        const myUploadFn = (param) => {

            const serverURL = '/Ajax/uploads'
            const xhr = new XMLHttpRequest
            const fd = new FormData()

            const successFn = (response) => {
                // 假设服务端直接返回文件上传后的地址
                // 上传成功后调用param.success并传入上传后的文件地址
                let reg = /["\\]/g
                var url = xhr.responseText.replace(reg, "");
                param.success({
                    // url: xhr.responseText,
                    url: url,
                    meta: {
                        // id: 'xxx',
                        // title: 'xxx',
                        // alt: 'xxx',
                        loop: false, // 指定音视频是否循环播放
                        autoPlay: false, // 指定音视频是否自动播放
                        controls: true, // 指定音视频是否显示控制栏
                        poster: '', // 指定视频播放器的封面
                    }
                })
            }

            const progressFn = (event) => {
                // 上传进度发生变化时调用param.progress
                param.progress(event.loaded / event.total * 100)
            }

            const errorFn = (response) => {
                // 上传发生错误时调用param.error
                param.error({
                    msg: 'unable to upload.'
                })
            }

            xhr.upload.addEventListener("progress", progressFn, false)
            xhr.addEventListener("load", successFn, false)
            xhr.addEventListener("error", errorFn, false)
            xhr.addEventListener("abort", errorFn, false)

            fd.append('file', param.file)
            xhr.open('POST', serverURL, true)
            xhr.send(fd)

        }
        const controls = [
            'undo', 'redo', 'separator',
            'font-size', 'line-height', 'letter-spacing', 'separator',
            'text-color', 'bold', 'italic', 'underline', 'strike-through', 'separator',
            'superscript', 'subscript', 'remove-styles', 'separator', 'text-indent', 'text-align', 'separator',
            'headings', 'list-ul', 'list-ol', 'code', 'blockquote', 'table', 'media', 'separator',
            'hr', 'link', 'separator', 'separator',
            'clear'
        ]
        const extendControls = [
            {
                key: 'antd-uploader',
                type: 'component',
                component: (
                    <Upload
                        showUploadList={false}
                        action="/Ajax/upload"
                        onChange={this.picChange2.bind(this, 'editorState')}
                    >
                        {/* 这里的按钮最好加上type="button"，以避免在表单容器中触发表单提交，用Antd的Button组件则无需如此 */}
                        <Button className="control-item button upload-button" data-title="上传附件">
                            <FolderAddOutlined />
                        </Button>
                    </Upload>
                )
            }
        ]
        return (
            <>
                {this.props.id ?
                    <a href='javascript:void(0)' onClick={this.mdchange.bind(this)}>编辑</a>
                    :

                    <>
                        <Button type="primary" icon={<PlusOutlined />}
                            onClick={this.mdchange.bind(this)}>新增项目</Button>
                    </>
                }

                <Modal title="编辑" maskClosable={false} destroyOnClose={true} width={900} visible={this.state.visible}
                    onCancel={this.mdchange.bind(this)} footer={null}>
                    <Form
                        layout="vertical"
                        // labelCol={{ span: 3 }}
                        wrapperCol={{ span: 24 }}
                        autoComplete="off"
                    >
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={24}>
                                <Form.Item>
                                    <Alert
                                        message="投资方（企业全称）或联系电话重复，则禁止添加"
                                        type="info"
                                        showIcon
                                    />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="项目名称"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.title ? this.state.condition.title : null}
                                        onChange={this.onChange.bind(this, 'title')} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="项目进度"
                                    required={true}
                                >
                                    <Radio.Group onChange={this.onChange.bind(this, 'project_progress')}
                                        value={this.state.condition.project_progress ? this.state.condition.project_progress : null}>
                                        {this.arrradio(this.state.project_progress_react)}
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                            {this.state.condition.project_progress == 2 ? <>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="落地时间"
                                        required={true}
                                    >
                                        <DatePicker className="input" placeholder="请选择"
                                            picker='month'
                                            onChange={this.onTimeChange.bind(this, 'landing_time')}
                                            value={this.state.condition.landing_time ? moment(this.state.condition.landing_time) : null}
                                            style={{ width: "100%" }}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="落地载体"
                                        required={true}
                                    >
                                        <Input placeholder="请输入"
                                            value={this.state.condition.landing_carrier ? this.state.condition.landing_carrier : null}
                                            onChange={this.onChange.bind(this, 'landing_carrier')} />
                                    </Form.Item>
                                </Col>
                            </> : null}
                            {this.state.condition.project_progress == 3 ? <>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="终止时间"
                                        required={true}
                                    >
                                        <DatePicker className="input" placeholder="请选择"
                                            picker='month'
                                            onChange={this.onTimeChange.bind(this, 'end_time')}
                                            value={this.state.condition.end_time ? moment(this.state.condition.end_time) : null}
                                            style={{ width: "100%" }}
                                        />
                                    </Form.Item>
                                </Col>
                            </> : null}
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="项目负责人"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.fzr_name ? this.state.condition.fzr_name : null}
                                        onChange={this.onChange.bind(this, 'fzr_name')} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="首次开拓时间"
                                    required={true}
                                >
                                    <DatePicker className="input" placeholder="请选择"
                                        onChange={this.onTimeChange.bind(this, 'sckt_time')}
                                        value={this.state.condition.sckt_time ? moment(this.state.condition.sckt_time) : null}
                                        style={{ width: "100%" }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="项目来源"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.origin_place ? this.state.condition.origin_place : null}
                                        onChange={this.onChange.bind(this, 'origin_place')} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="中介/基金名称"
                                // required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.fund_agency_name ? this.state.condition.fund_agency_name : null}
                                        onChange={this.onChange.bind(this, 'fund_agency_name')} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label={<Row justify={'space-between'} style={{ width: '100%' }}>
                                        <span>投资方（企业全称）</span>
                                        {/* <a href={'javascript:void(0)'} onClick={() => {
                                                this.getCompanyInfo()
                                            }}>一键获取工商信息</a> */}
                                    </Row>}
                                    className={'fullwidth'}
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.qy_name ? this.state.condition.qy_name : null}
                                        onChange={this.onChange.bind(this, 'qy_name')} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="联系人"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.lxr_name ? this.state.condition.lxr_name : null}
                                        onChange={this.onChange.bind(this, 'lxr_name')} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="联系电话"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.lxr_mobile ? this.state.condition.lxr_mobile : null}
                                        onChange={this.onChange.bind(this, 'lxr_mobile')} />
                                </Form.Item>
                            </Col>
                            {/* <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="资本类型"
                                    required={true}
                                >
                                    <Radio.Group onChange={this.onChange.bind(this, 'capital_type')}
                                        value={this.state.condition.capital_type ? this.state.condition.capital_type : null}>
                                        {this.arrradio(this.state.capital_type_react)}
                                    </Radio.Group>
                                </Form.Item>
                            </Col> */}
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="国家/地区"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.address ? this.state.condition.address : null}
                                        onChange={this.onChange.bind(this, 'address')} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="行业类别"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                        value={this.state.condition.industry_type ? this.state.condition.industry_type : null}
                                        onChange={this.onChange.bind(this, 'industry_type')} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="经济类别"
                                    required={true}
                                >
                                    <Select placeholder="请选择"
                                        style={{ width: "100%" }}
                                        value={this.state.condition.economic_type ? this.state.condition.economic_type : null}
                                        onChange={this.onSelChange.bind(this, 'economic_type')} allowClear showSearch
                                        optionFilterProp="children">
                                        {this.arrsel(this.state.economic_type_react)}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="面积"
                                    required={true}
                                >
                                    <Input.Group compact>
                                        <Input placeholder="请输入"
                                            type="number"
                                            min={0}
                                            step={0.01}
                                            style={{ width: 'calc(100% - 120px)' }}
                                            value={this.state.condition.mianji ? this.state.condition.mianji : null}
                                            onChange={this.onChange.bind(this, 'mianji')} />
                                        <Select
                                            // mode="multiple"
                                            allowClear
                                            style={{ width: 120 }}
                                            placeholder="单位"
                                            value={this.state.condition.mianji_unit ? this.state.condition.mianji_unit : []}
                                            onChange={this.onSelChange.bind(this, 'mianji_unit')}
                                            maxTagCount="responsive"
                                            showSearch
                                            optionFilterProp="children"
                                        >
                                            {this.arrsel(this.state.mianji_unit_react)}
                                        </Select>
                                    </Input.Group>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="拟投资额"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                        type="number"
                                        min={0}
                                        step={0.01}
                                        value={this.state.condition.touzi_price ? this.state.condition.touzi_price : null}
                                        onChange={this.onChange.bind(this, 'touzi_price')} suffix="万元" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="项目标签"
                                // required={true}
                                >
                                    <Select placeholder="请选择"
                                        mode="multiple"
                                        maxTagCount="responsive"
                                        style={{ width: "100%" }}
                                        value={this.state.condition.project_tags ? this.state.condition.project_tags : []}
                                        onChange={this.onSelChange.bind(this, 'project_tags')} allowClear showSearch
                                        optionFilterProp="children">
                                        {this.arrsel(this.state.project_tags_react)}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={24}>
                                <Form.Item
                                    label="项目简介"
                                    required={true}
                                >
                                    <div className="editor-wrapper" style={{ border: '1px solid #bbb' }}>
                                        <BraftEditor
                                            value={this.state.condition.editorState}
                                            onChange={this.editorChange}
                                            controls={controls}
                                            media={{ uploadFn: myUploadFn }}
                                            extendControls={extendControls}
                                        />
                                    </div>
                                </Form.Item>
                            </Col>
                            {this.state.is_special_user ?
                                <Col className="gutter-row" span={24}>
                                    <Form.Item
                                        label="项目备注"
                                    // required={true}
                                    >
                                        <TextArea placeholder="请输入"
                                            rows={5}
                                            value={this.state.condition.remark ? this.state.condition.remark : null}
                                            onChange={this.onChange.bind(this, 'remark')} />
                                    </Form.Item>
                                </Col>
                                : null}
                            <Col className="gutter-row" span={24}>
                                <Form.Item>
                                    <Row justify={"center"}>
                                        <Button type='primary' onClick={this.sub.bind(this)}
                                            loading={this.state.loading}>提交</Button>
                                    </Row>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
            </>
        )
    }
}

export default Edit
